module.exports = __webpack_public_path__ + "img/04E804_04B504_04CB04_33FC33-256px.8a37c4f2.png";